import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrdGenerator"] */ "/opt/buildhome/repo/src/app/(marketing)/tools/prd-generator/generator.tsx");
